export const SPARK_SITE_URL = 'https://spark.lcp.com';
export const SPARK_DEFAULT_OG_IMAGE_URL = `${SPARK_SITE_URL}/spark-home.png`;
